package com.appcreator.blueprint.components.basic

import com.appcreator.blueprint.core.Action
import com.appcreator.blueprint.core.Component
import com.appcreator.blueprint.core.ComponentClass
import com.appcreator.blueprint.core.InputProperty
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@SerialName("ActionComponent")
@ComponentClass(
    group = "Basic",
    title = "Action",
    availableFrom = "0.0.1"
)
data class ActionComponent(

    override val _nodeId: String?,
    override val _nodeLabel: String?,
    override val _nodeRelativeId: String?,

    @InputProperty(
        title = "Perform On Appear",
        availableFrom = "0.0.1"
    )
    val performOnAppear: Boolean?,

    @InputProperty(
        title = "Perform On Trigger",
        availableFrom = "0.0.1"
    )
    val performOnTrigger: String?,

    @InputProperty(
        title = "Action",
        availableFrom = "0.0.1"
    )
    val action: Action?

): Component